import React, { memo } from 'react';
var _ref = /*#__PURE__*/React.createElement("div", {
  className: "w5-tooltip"
}, /*#__PURE__*/React.createElement("div", {
  className: "w5-tooltip-content"
}), /*#__PURE__*/React.createElement("div", {
  className: "w5-tooltip-arrow",
  "data-popper-arrow": true
}));
const Tooltip = /*#__PURE__*/memo(() => {
  return _ref;
});
export default Tooltip;